import React, { useEffect } from 'react'
import { FileIcon } from '@entur/icons'
import { useToast } from '@entur/alert'
import { OverflowMenuItem } from '@entur/menu'
import { DownloadCompletedAction, useDownloadableApi } from '../../api-clients/client-hooks'
import { useEmployee } from '../../contexts/employee-context'
import { getDisclosureDocument } from '../../api-clients/eba-clients'
import { FetchState } from '../../api-clients/api-types'
import { useClientInfo } from '../../contexts/client-info-context'

type DisclosureDocumentProps = {
  setErrorMessage: (errorMsg: string | undefined) => void
}
export const DisclosureDocument: React.FC<DisclosureDocumentProps> = ({ setErrorMessage }) => {
  const { addToast } = useToast()
  const { employee } = useEmployee()
  const { hasSensitiveAccess } = useClientInfo()

  const [disclosureDocumentResponse, downloadDisclosureDocument] = useDownloadableApi(
    getDisclosureDocument,
    DownloadCompletedAction.PRINT
  )

  const clickDownloadDisclosureDocument = () => {
    addToast({ variant: 'info', content: 'Laster ned innsynsdokument...' })
    downloadDisclosureDocument({
      id: employee.id,
      backupFileName: 'innsynsdokument.pdf',
    })
  }

  useEffect(() => {
    if (disclosureDocumentResponse.status === FetchState.ERROR) {
      setErrorMessage('Kan ikke skrive ut innsynsdokument')
    }
  }, [setErrorMessage, disclosureDocumentResponse])

  const btn = (
    <OverflowMenuItem
      data-cy="disclosure-document-button"
      className="disclosure-document-button"
      onSelect={clickDownloadDisclosureDocument}
    >
      <span aria-disabled>
        <FileIcon inline />
        Innsynsdokument
      </span>
    </OverflowMenuItem>
  )

  return hasSensitiveAccess === true ? btn : <></>
}
